<script setup>

import { ref, onMounted ,watch} from 'vue';
import DynamicForm from './DynamicForm.vue';
import { buildSchema } from './AllegroOfferSchemaBuilder.js';
import AllegroDescriptionEditor from './AllegroDescriptionEditor.vue';

console.log('AllegroDescriptionEditor:', AllegroDescriptionEditor);

const offer = defineModel();
const schema = ref();

onMounted(async () => {
  
    console.log(offer.value);
    schema.value = buildSchema(offer.value);

});

watch(
    offer,
    (newValue) => {

        console.log('offer changed');

        schema.value = buildSchema(newValue);

    },
    // {
    //     deep: true
    // }
);

function goTo(name){

    document
        .getElementById("Id_GoTo_"+name)
        ?.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
}

</script>

<template>

    <div class="card mb-4" id="EditParameters">
        <div style="position:sticky;top:20px;max-height:90vh;overflow:auto;margin-left: 10px;margin-top: 10px;z-index: 100;">
            <button class="btn btn-secondary" @click="goTo('Top')">Przejdz do góry</button> |   
            <button class="btn btn-secondary" @click="goTo('Preview')">Przejdz do podglądu</button> |   
            <button class="btn btn-secondary" @click="goTo('Edit')">Przejdz do edytora</button>  
        </div>
        <div class="card-header pb-0">
            <h6>Edycja parametrów</h6>
        </div>
        
        <div class="card-body px-0 pt-0 pb-2">
            <dynamic-form 
                v-if="offer"
                :model="offer"
                :schema="schema"
            />
        </div>
    <div class="container-fluid p-0" style="max-width: 1200px;" id="Id_GoTo_Edit">
        <allegro-description-editor v-model:sections="offer.description.sections" />
    </div>

    </div>
   
     
        

</template>